<h2 class="title">datas desejadas</h2>

<div [formGroup]="datesForm">
  <div class="date-options-grid">
    <mat-radio-group formControlName="fRbDate" class="date-option-radio-group" aria-labelledby="radio-group-label">
      <mat-radio-button class="date-option-radio-button" (change)="dateOptionsChange($event)" [value]="dateOptions[0]">
        {{ dateOptions[0] }}</mat-radio-button>
      <mat-radio-button class="date-option-radio-button" (change)="dateOptionsChange($event)" [value]="dateOptions[1]">
        {{ dateOptions[1] }}</mat-radio-button>
    </mat-radio-group>
  </div>
  <div formArrayName="dateArray">
    <div *ngIf="listType" class="date-picker">
      <div *ngFor="let item of dateArray.controls; let i=index" class="toogle-date-grid date-width">
        <div>
          <label class="label-date">{{getDatePickerLabel(i)}}</label>
          <div>
            <mat-form-field>
              <input matInput [matDatepicker]="picker" id="{{getDatePickerLabel(i)}}" [formControlName]="i" class="data-input">
              <mat-datepicker-toggle matSuffix [for]="picker" class="toggle-date"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
            <mat-error *ngIf="ngForm.submitted && dateArray.controls[i].errors?.required ">
              Campo obrigatório.</mat-error>
          </div>
        </div>
      </div>
    </div>
  </div>

  <h2 class="title" *ngIf="selectedDates && selectedDates.length > 0">data final</h2>

  <div formArrayName="dateArrayFinal" *ngIf="selectedDates && selectedDates.length > 0" >
    <div *ngIf="listType" class="date-picker">
      <div *ngFor="let item of dateArrayFinal.controls; let i=index" class="toogle-date-grid date-width">
        <div>
          <label class="label-date">{{getDatePickerLabel(i)}}</label>
          <div>
            <mat-form-field>
              <input matInput [matDatepicker]="picker" id="{{getDatePickerLabel(i)}}" [formControlName]="i" class="data-input">
              <mat-datepicker-toggle matSuffix [for]="picker" class="toggle-date"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
            <mat-error *ngIf="selectedDates && selectedDates.length > 0 && ngForm.submitted && dateArrayFinal.controls[i].errors?.required ">
              Campo obrigatório.</mat-error>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
